// Tiny shared chrome used across brochure pages.

export const PageFooter = ({ num, total = 16 }) => (
  <div className="page-footer">
    <span>INPACE POWER · COMPANY BROCHURE · MMXXVI</span>
    <span>
      <span className="num">{num}</span> / {total}
    </span>
  </div>
);

export const Corner = ({ section }) => (
  <div className="corner-mark">
    <span>§</span> {section}
  </div>
);
